import { render, staticRenderFns } from "./TableRiskAssemblyRecord.vue?vue&type=template&id=291f0454&scoped=true"
import script from "./TableRiskAssemblyRecord.vue?vue&type=script&lang=js"
export * from "./TableRiskAssemblyRecord.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAssemblyRecord.vue?vue&type=style&index=0&id=291f0454&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291f0454",
  null
  
)

export default component.exports